import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import {
  Grid,
  Paper,
  Typography,
  Button,
  Link as MuiLink,
} from '@material-ui/core'

import Link from '../controls/Link'
import { resetPassword, getErrorText } from '../../utils/AuthService'
import Layout from './Layout'
import ErrorView from './ErrorView'

import SmallArrowRight from '../../../assets/images/icons/ico_arrow_small.svg'

class ForgotPassword extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
  }

  static styles = (theme) => ({
    promptPaper: {
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        padding: theme.spacing(3),
      },
      [theme.breakpoints.up('md')]: {
        width: 'auto',
        maxWidth: '520px',
        padding: theme.spacing(5),
      },
    },
    buttonContained: theme.buttonContained,
    link: theme.loginLink,
    email: {
      margin: theme.spacing(3, 0),
      fontWeight: 500,
    },
  })

  state = {
    resend: false,
    error: null,
  }

  handleError = (error) => {
    if (error) {
      this.setState({ error: { text: getErrorText(error) } })
    }
  }

  handlePasswordReset = (email) => {
    resetPassword(email, this.handleError)
    this.setState({ resend: true })
  }

  email() {
    const { email } = this.props.location.state
    return email
  }

  displayText() {
    const { resend } = this.state
    if (resend) {
      return {
        title: 'Check your email',
        subtitle: 'You should receive a reset link to your email address shortly.',
        primaryAction: 'Resend link',
        secondaryAction: 'Return to sign in',
      }
    }
    return {
      title: 'Forgot your password?',
      subtitle: 'We\'ll send a password reset link to:',
      email: this.email(),
      primaryAction: 'Get reset link',
      secondaryAction: 'Return to sign in',
    }
  }

  render() {
    const { classes } = this.props
    const { error } = this.state
    const email = this.email()
    const displayText = this.displayText()

    if (error) {
      return (
        <Layout>
          <Paper elevation={3} square classes={{ root: classes.promptPaper }}>
            <ErrorView error={error} />
          </Paper>
        </Layout>
      )
    }

    return (
      <Layout>
        <Paper elevation={3} square classes={{ root: classes.promptPaper }}>
          <Typography variant="h1">{displayText.title}</Typography>
          <Typography variant="h2">{displayText.subtitle}</Typography>
          <Typography variant="h5" className={classes.email}>{displayText.email}</Typography>
          <Grid container justify="space-between" alignItems="center">
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={() => this.handlePasswordReset(email)}
                classes={{ contained: classes.buttonContained }}
              >
                {displayText.primaryAction}
                <img src={SmallArrowRight} alt="→" />
              </Button>
            </Grid>
            <Grid item>
              <MuiLink component={Link} to="/login" className={classes.link}>
                {displayText.secondaryAction}
              </MuiLink>
            </Grid>
          </Grid>
        </Paper>
      </Layout>
    )
  }
}

export default withStyles(ForgotPassword.styles)(ForgotPassword)
